/* eslint-disable */
import { Component, OnInit } from '@angular/core';
import { AlertController, NavParams, PopoverController } from '@ionic/angular';
import { TranslateService } from '@ngx-translate/core';
import { CONSTANTS } from 'src/app/services/config.service';

@Component({
  selector: 'app-day-start-end',
  templateUrl: './day-start-end.page.html',
  styleUrls: ['./day-start-end.page.scss']
})
export class DayStartEndPage implements OnInit {
  places: any = [];

  constructor(
    private navParams: NavParams,
    private translate: TranslateService,
    private popoverCtrl: PopoverController,
    private alertCtrl: AlertController
  ) {}

  async presentAlertTraveling() {
    const p = this.navParams.data.activePerson;
    const localTranslationData = {
      name: p.name,
      nameDisplay: p.nameDisplay
    };
    const alert = await this.alertCtrl.create({
      // title: 'Started day',
      // message: "Since " + this.activePerson.name + " was traveling, please answer with the last place " + this.activePerson.nameDisplay + " stopped BEFORE 3:00 AM (even if it was a short stop such as to get gas).",
      // message: "Since {{ name }} was traveling, please answer with the last place {{ nameDisplay }} stopped BEFORE 3:00 AM (even if it was a short stop such as to get gas).",
      message: this.translate.instant('DAY_START_END_ALERT_TRAVELING_MSG', localTranslationData),
      buttons: [
        {
          text: this.translate.instant('BUTTON_OK')
        }
      ]
    });

    await alert.present();
  }

  onClickPlace(place) {
    if (place.id === 'TRAVELING') {
      this.presentAlertTraveling();
    } else {
      this.popoverCtrl.dismiss(place);
    }
  }

  init() {
    const p = this.navParams.data.activePerson;
    const localTranslationData = { nameDisplay: p.nameDisplay };

    const genericPlaces = [
      {
        id: 'OTHERS_HOME',
        // text: "Someone else's home", prompt: "someone else's home", example: "John's house",
        label: this.translate.instant('DAY_START_END_PLACE_OTHERS_HOME_TEXT'),
        prompt: this.translate.instant('DAY_START_END_PLACE_OTHERS_HOME_PROMPT'),
        example: this.translate.instant('DAY_START_END_PLACE_OTHERS_HOME_EXAMPLE')
      },
      {
        id: 'SECOND_HOME',
        // text: p.nameDisplay + "'s other home (e.g., second home)", prompt: p.nameDisplay + "'s other home", example: "Beach house"
        label: this.translate.instant('DAY_START_END_PLACE_SECOND_HOME_TEXT', localTranslationData),
        prompt: this.translate.instant('DAY_START_END_PLACE_SECOND_HOME_PROMPT', localTranslationData),
        example: this.translate.instant('DAY_START_END_PLACE_SECOND_HOME_EXAMPLE', localTranslationData)
      },
      {
        id: 'HOTEL',
        // text: "Temporary lodging (e.g., hotel, vacation rental, campground)", prompt: "a hotel, vacation rental, etc", example: "Holiday Inn"
        label: this.translate.instant('DAY_START_END_PLACE_HOTEL_TEXT'),
        prompt: this.translate.instant('DAY_START_END_PLACE_HOTEL_PROMPT'),
        example: this.translate.instant('DAY_START_END_PLACE_HOTEL_EXAMPLE')
      },
      {
        id: 'TRAVELING',
        // text: "Traveling at 3AM (e.g., red-eye flight)", prompt: "", example: ""
        label: this.translate.instant('DAY_START_END_PLACE_TRAVELING_TEXT'),
        prompt: '',
        example: ''
      },
      {
        id: 'OTHER',
        // text: "Other", prompt: "an 'other' place", example: "Campsite"
        label: this.translate.instant('DAY_START_END_PLACE_OTHER_TEXT'),
        prompt: this.translate.instant('DAY_START_END_PLACE_OTHER_PROMPT'),
        example: this.translate.instant('DAY_START_END_PLACE_OTHER_EXAMPLE')
      }
    ];

    // only use survey subject's hab locs
    const habLocs = p.habLocs.filter((l) => l.isSubjectsLoc === true);

    // if we have a second home loc from the signup, we don't need the generic option
    const hasOtherHome = habLocs.filter((l) => l.id === CONSTANTS.HABITUAL_LOCS.OTHER_HOME).length;
    if (hasOtherHome == true) {
      genericPlaces.splice(1, 1);
    }

    this.places = habLocs.concat(genericPlaces);
  }

  ionViewWillEnter() {
    this.init();
  }

  ngOnInit() {}
}
